<template>
    <div
        v-if="isShowModal"
        :style="componentStyles"
        class="o-sms-modal-standard"
    >
        <div class="sms-modal-standard-container">
            <div class="sms-modal-standard-header">
                <div
                    v-if="icon"
                    class="sms-modal-standard-logo"
                >
                    <img
                        :src="icon"
                        class="sms-modal-standard-image"
                    >
                </div>
                <div class="sms-modal-standard-header-wrapper">
                    <span class="sms-modal-standard-title">
                        {{ $t("ui.modal.sms.title", { storename: name }, name)}}
                    </span>
                    <AFloorInfo 
                        :text="floorInfo"
                    />
                </div>
            </div>
            <div
                v-if="isInput"
                class="sms-modal-standard-wrapper sms-modal-standard-input"
            >
                <span
                    v-if="!isValid"
                    class="sms-modal-standard-error-message"
                    v-html="$t('ui.popup.not-valid-number', {value: value})"
                />
                <div :class="['sms-modal-standard-input-wrapper', {'sms-modal-standard-input-wrapper-not-valid': !isValid}]">
                    <input
                        v-model="value"
                        type="tel"
                        class="sms-modal-standard-input-field"
                        disabled
                    >
                    <button
                        type="button"
                        class="sms-modal-standard-input-button"
                        @click="removeValue"
                    >
                        <span class="sms-modal-standard-button-placeholder">
                            {{"Delete" | translate}}
                        </span>
                    </button>
                </div>
                <div class="sms-modal-standard-keyboard-container">
                    <div class="sms-modal-standard-keyboard">
                        <button
                            type="button"
                            class="sms-modal-standard-key"
                            v-for="key in $options.KEYBOARD_KEYS"
                            :key="key"
                            @click="clickKey(key)"
                        >
                            {{ key }}
                        </button>
                    </div>
                </div>
            </div>
            <OSmsModalStandardSuccess
                v-if="isSuccess"
                :phone="value"
            />
            <OSmsModalStandardFail
                v-if="isFailure"
                :message="message"
            />
            <div class="sms-modal-standard-footer">
                <button
                    type="button"
                    class="sms-modal-standard-button"
                    @click="handleSendSms"
                >
                    <span>
                        {{ sendSmsButtonTitle }}
                    </span>
                </button>
            </div>
            <button
                type="button"
                class="sms-modal-standard-close-button"
                @click="closeModal"
            />

        </div>
    </div>
</template>

<script>
import {
    mapActions,
    mapGetters
} from "vuex";

import AFloorInfo from '../../atoms/a-floor-info';
import OSmsModalStandardFail from '../../unique-organisms/o-sms-modal-standard-fail';
import OSmsModalStandardSuccess from '../../unique-organisms/o-sms-modal-standard-success';

import { EVENTS } from "@/utils/constants/bus-events-constants";
import {
    COUNTRIES_CODES,
    KEYBOARD_KEYS,
    TEL_NUMBER_REG_EXP
} from "@/components/organisms/o-sms-modal-standard/constsnts";

export default {
    name: "OSmsModalStandard",
    components: {
        AFloorInfo,
        OSmsModalStandardFail,
        OSmsModalStandardSuccess
    },
    data() {
        return {
            isShowModal: false,
            value: '+47',
            isValid: true,
            config: {},
            state: 'input',
            message: ''
        }
    },
    computed: {
        ...mapGetters([
            't',
            'getObject',
            'getTerminalId',
            'getActiveLocale',
            'getMapConfigProp',
        ]),
        defaultCountryCode(){
            return COUNTRIES_CODES.find(c => c.locale === this.getActiveLocale)?.code;
        },
        isInput() {
            return this.state === 'input';
        },
        isSuccess() {
            return this.state === 'success';
        },
        isFailure() {
            return this.state === 'failure';
        },
        componentStyles() {
            return this.getMapConfigProp(`views.${this.config.view}.mainFrame.OGuideSidebar.params.OSmsModalStandard.styles`) || null;
        },
        item() {
            return this.getObject(this.config.itemId)
        },
        name() {
            return this.t(this.item, 'name') || '';
        },
        floorInfo() {
            return this.t(this.item, 'floor') || '';
        },
        icon() {
            return this.item?.files?.icon || '';
        },
        sendSmsButtonTitle() {
            return this.state === 'input'
                ? this.$t('ui.way.send_sms')
                : this.$t('ui.resend-sms');
        }
    },
    mounted() {
        this.initListeners();
        this.value = this.defaultCountryCode;
    },
    beforeDestroy() {
        this.removeListeners();
    },
    watch: {
        value() {
            this.isValid = true
        }
    },
    methods: {
        ...mapActions([
            'sendSms'
        ]),
        initListeners() {
            this.$bus.$on(EVENTS.MODALS.INIT_SMS_MODAL_STANDARD, this.showModal);
        },
        removeListeners() {
            this.$bus.$off(EVENTS.MODALS.INIT_SMS_MODAL_STANDARD, this.showModal);
        },
        showModal(config) {
            this.config = config;
            this.isShowModal = true;
        },
        closeModal() {
            this.state = 'input';
            this.value = this.defaultCountryCode;
            this.isValid = true;
            this.message = '';
            this.isShowModal = false;
        },
        removeValue() {
            if(this.value.length > 1) {
                this.value = this.value.substring(0, this.value.length - 1);
            }
        },
        clickKey(value) {
            this.value += value;
        },
        async handleSendSms() {
            if( this.value.match(TEL_NUMBER_REG_EXP) ){
                const params = {
                    phone: this.value,
                    from:  this.getTerminalId,
                    to: this.item.id,
                    mode: this.$route.params.type,
                };

                try {
                    await this.sendSms(params);
                    this.state = 'success';
                } catch(error) {
                    this.state = 'failure';
                    this.message = _.has(error,'response.data.messages[0]')
                        ? _.get(error,'response.data.messages[0]')
                        :  _.get(error,'response.data.errors.phone[0]');
                }
            } else{
                this.isValid = false
            }
        }
    },
    KEYBOARD_KEYS
}
</script>

<style lang="scss">
@import "theme";
</style>
